import { observer } from 'mobx-react-lite';
import { SyntheticEvent, useEffect, useState } from 'react';
import { Button, Modal } from 'semantic-ui-react';
import 'react-html5-camera-photo/build/css/index.css';
import { v4 as uuid } from 'uuid';
import { useStore } from '../../../app/stores/store';
import agent from '../../../app/api/agent';
import { userLanguage } from '../../../app/common/userLanguageSchema/userLanguage';
import Camera from 'react-html5-camera-photo';
import { Image } from 'semantic-ui-react';

export type PhotoType = {
  id: string;
  photoId: string;
  photoName: string;
  url: string;
};

interface Props {
  getUploadedPhotos: (uploadedPhotos: PhotoType, index: number) => void;
  index: number;
  cancelHandler?: () => void;
  fromDashboard?: boolean;
  duplicateFormDetails?: any[];
}
function CamModal({
  getUploadedPhotos,
  index,
  cancelHandler,
  fromDashboard,
  duplicateFormDetails,
}: Props) {
  const {
    dashboardStore,
    commonStore,
    activityStore: { selectedActivity },
    WorkLevelStore,
  } = useStore();
  const [loading, setLoading] = useState(false);
  // const [uploadedPhotos, setUploadedPhotos] = useState<PhotoType>({
  //   id: '',
  //   photoId: '',
  //   photoName: '',
  //   url: '',
  // });
  const [, setOpen] = useState(false);
  const [addPhoto, setAddPhoto] = useState<Blob[]>([]);
  const [preview, setpreview] = useState<File[]>([]);

  //static for Academy
  const [project, setProject] = useState<string>('');
  const [projectTitle, setProjectTitle] = useState<string>('');

  useEffect(() => {
    //static for Academy
    if (
      duplicateFormDetails !== undefined &&
      duplicateFormDetails?.length > 0 &&
      commonStore.staticDemoChanges
    ) {
      duplicateFormDetails?.forEach((data) => {
        if (data.elementName === 'Project') {
          setProject(data.elementValue);
        }
        if (data.elementName === 'Project Title') {
          setProjectTitle(data.elementValue);
        }
      });
    }
  }, [duplicateFormDetails, commonStore.staticDemoChanges]);

  function handleTakePhoto(dataUri: any) {
    setpreview([...preview, dataUri]);
    const arr = dataUri.split(',');
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    var n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    setAddPhoto([...addPhoto, new Blob([u8arr], { type: mime })]);
  }

  useEffect(() => {
    if (commonStore.devEnv)
      WorkLevelStore.loadWorkLevelBasedOnItemLevel(selectedActivity?.id);
    // eslint-disable-next-line
  }, [selectedActivity?.id]);

  const finalupload = (e: SyntheticEvent) => {
    e.preventDefault();
    setLoading(true);
    addPhoto?.forEach(async (file: any) => {
      let FileNameChangedata: PhotoType = {
        photoId: '',
        id: '',
        photoName: '',
        url: '',
      };
      if (commonStore.devEnv) {
        const item = fromDashboard
          ? projectTitle || 'Dummy Item'
          : selectedActivity?.id;
        const workLevel = fromDashboard
          ? project?.split('|')?.[1] || 'Dummy WorkLevel'
          : dashboardStore.dashboard.dashboardWorkLevelMaster?.id;
        const response = await agent.Files.localFileUpload(
          file,
          workLevel,
          item,
        );
        const url = response?.data.path.replace(/\\\\/g, '\\');
        const filename = url.substring(url.lastIndexOf('\\') + 1);
        FileNameChangedata = {
          photoId: uuid(),
          id: response.data.id,
          url: url,
          photoName: filename
            .concat(' Task Form ')
            .concat(new Date().toLocaleString()),
        };
        dashboardStore.getLocalFilesBasedOnItem(item);
      } else {
        const response = await agent.Files.uploadCameraImage(file);
        FileNameChangedata = {
          photoId: uuid(),
          id: response.data.id,
          url: response.data.url,
          photoName: response.data.fileName
            .concat('Task Form ')
            .concat(new Date().toLocaleString()),
        };
      }

      // setUploadedPhotos(FileNameChangedata);
      getUploadedPhotos(FileNameChangedata, index);

      cancelHandler?.();
      setTimeout(() => {
        dashboardStore.setOpenCameraModal(false);
      }, 1000);
    });
    setAddPhoto([]);
  };
  const handleCancel = () => {
    cancelHandler?.();
    dashboardStore.setOpenCameraModal(false);
    setAddPhoto([]);
  };

  return (
    <>
      <div>
        <Modal
          onClose={() => {
            setOpen(false);
            cancelHandler?.();
          }}
          onOpen={() => setOpen(true)}
          open={true}
        >
          <Modal.Header
          //Camera
          >
            {
              (
                userLanguage[0].Level3InventoryRecievingRegisterCameraModal
                  ?.IRRCML01 as any
              )?.[`${commonStore.language.key}`]
            }
          </Modal.Header>
          <Modal.Content>
            <Modal.Description>
              <div>
                <Camera
                  onTakePhoto={(dataUri:any) => {
                    handleTakePhoto(dataUri);
                  }}
                  idealFacingMode="environment"
                  imageCompression={0.92}
                />
                <div className="photocamimg">
                  {preview.map((blob, i) => (
                    <Image key={i} style={{ height: '120px' }} src={blob} />
                  ))}
                </div>
              </div>
            </Modal.Description>
          </Modal.Content>
          <Modal.Actions>
            <Button
              onClick={handleCancel}
              //Cancel
            >
              {
                (
                  userLanguage[0].Level3InventoryRecievingRegisterCameraModal
                    ?.IRRCMB01 as any
                )?.[`${commonStore.language.key}`]
              }
            </Button>
            <Button
              disabled={addPhoto.length > 0 ? false : true}
              loading={loading}
              content={
                (
                  userLanguage[0].Level3InventoryRecievingRegisterCameraModal
                    ?.IRRCMB02 as any
                )?.[`${commonStore.language.key}`]
              } //"Save"
              labelPosition="right"
              icon="checkmark"
              onClick={(e) => finalupload(e)}
              positive
            />
          </Modal.Actions>
        </Modal>
      </div>
    </>
  );
}

export default observer(CamModal);
